import { useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import PropTypes, { object } from "prop-types";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Grid,
  Hidden,
  List,
  Typography,
  Collapse,
} from "@mui/material";
import {
  LogOut as LogOutIcon,
  BarChart as BarChartIcon,
  FileText as FileTextIcon,
  Clock as ClockIcon,
  Inbox as InboxIcon,
  Home as HomeIcon,
  Book as BookIcon,
  Users as UsersIcon,
  Edit as EditIcon,
  Target as TargetIcon,
} from "react-feather";
import NavItem from "./NavItem";
import NavItemLogOut from "./NavItemLogOut";
import { useTranslation } from "react-i18next";
import { makeStyles, styled } from "@mui/styles";
import SubMenu from "./SubMenu";
import React, { useState } from "react";
import arrow from "../assets/images/arrow-right.svg";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Achievements from "../assets/images/achievements.svg";
import Goals from "../assets/images/goals.svg";
import Competencies from "../assets/images/competencies.svg";
import EvaluationManage from "../assets/images/evaluationManage.svg";
import HistoryEvaluation from "../assets/images/history.svg";
import Home from "../assets/images/home.svg";
import Inbox from "../assets/images/inbox.svg";
import Book from "../assets/images/achievements.svg";
import FileText from "../assets/images/file-text.svg";
import UserCircle from "../assets/images/user-circle.svg";
import LaunchForm from "../assets/images/launch-form.svg";
import Report from "../assets/images/report.svg";
import Profile from "../assets/images/profileicon.svg";
import Announcement from "../assets/images/announcement.svg";
import Security from "../assets/images/security.svg";
import Calibration from "../assets/images/calibration.svg";
import External from "../assets/images/external.svg";
import MyFeedbacks from "../assets/images/myFeedbacks.svg";
import EmailNotification from "../assets/images/email-cog.svg";
import ImportFile from "../assets/images/import_files.svg";
import Evaluation360 from "../assets/images/360-degrees.svg";
import { findIndex } from 'lodash';
import * as Util from "../services/global.service";
// import LogOut from "../assets/images/logout.svg";

const user = {
  avatar: "/static/images/avatars/avatar_6.png",
  // jobTitle: "Senior Developer",
  // name: "Katarina Smith",
};
const styles = {
  colorDivider: {
    backgroundColor: "#FFFFFF",
  }
}
const DashboardSidebar = ({ onMobileClose, openMobile, item }) => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [subnav, setSubnav] = useState(false);
  const [fullName, setFullName] = useState("");
  const [imageProfile, setImageProfile] = useState("");
  const showSubnav = () => setSubnav(!subnav);
  const dataProfiles = JSON.parse(localStorage.getItem("user"));
  const proxy = JSON.parse(localStorage.getItem("proxy"));
  const [isCollapse, setCollapse] = React.useState(true);
  const [isCollapseManage, setCollapseManage] = React.useState(true);
  const [isCollapseAdmin, setCollapseAdmin] = React.useState(true);
  const [isCollapseReport, setCollapseReport] = React.useState(true);
  const [type, setType] = React.useState("kpi");
  const [position, setPosition] = useState();
  const [admin, setAdmin] = useState();
  const [codeMenu, setCodeMenu] = useState("");
  const [canView, setCanView] = useState();
  const [valueName, setValueName] = React.useState('');
  const [typeMenu, setTypeMenu] = React.useState('');
  const [menuReport, setMenuReport] = useState([]);


  let permission = proxy?.proxy_token !== undefined ? proxy?.permission : dataProfiles?.permission

  const isSSO = (dataProfiles?.is_sso)

  const handleCollapse = () => {
    setCollapse(!isCollapse)
  }
  const handleCollapseManage = () => {
    setCollapseManage(!isCollapseManage)
  }
  const handleCollapseManageSub = (data) => {
    // setCollapse(!isCollapse)
    if (data !== valueName) {
      setValueName(data)
    } else {
      setValueName("")
    }
  }
  const handleCollapseAdmins = () => {
    setCollapseAdmin(!isCollapseAdmin)
  }
  const handleCollapseReport = () => {
    setCollapseReport(!isCollapseReport)
  }
  const handleCollapseAdmin = (data, type) => {
    // setCollapse(!isCollapse)
    if ((data !== valueName && type !== typeMenu)) {
      setValueName(data)
      setTypeMenu(type)
    } else {
      setValueName("")
      setTypeMenu("")
    }
  }
  useEffect(() => {
    displayFullName()

  }, [dataProfiles]);
  useEffect(() => {
    checkDisplayMenuManage()
    checkDisplayMenuAdmin()
    checkDisplayMenuKpi()
    listExternal()
  }, []);
  const displayFullName = () => {
    if (dataProfiles !== undefined && dataProfiles !== "undefined" && dataProfiles !== null) {
      setFullName(dataProfiles?.profile?.firstname + ` ` + dataProfiles?.profile?.lastname)
      setImageProfile(dataProfiles?.profile?.photo)
      setPosition(dataProfiles?.is_manager)
      setAdmin(dataProfiles?.is_admin)
    }
  }
  const checkDisplayMenuKpi = () => {
    let hide = itemSubnavKpi.filter((item) =>
      item.height === false
    )
    if (hide.length === itemSubnavKpi.length) {
      return false
    } else {
      return true
    }
  }

  const checkDisplayMenuManage = () => {
    let lengthSubMenu = 0
    let lengthHideMenu = 0
    for (let index = 0; index <= itemSubnavManage.length - 1; index++) {
      lengthSubMenu += itemSubnavManage[index].subMenu.length
      if (itemSubnavManage[index].subMenu.length === 0) {
        if (itemSubnavManage[index].height === false) {
          lengthHideMenu++
        }
        lengthSubMenu++
      } else {
        let hide = itemSubnavManage[index].subMenu.filter((item) =>
          item.height === false
        )
        lengthHideMenu += hide.length
      }
    }
    if (lengthHideMenu === lengthSubMenu) {
      return false
    } else {
      return true
    }
  }

  const checkDisplayMenuAdmin = (dataMenu) => {
    let lengthSubMenu = 0
    let lengthHideMenu = 0
    if (dataMenu !== undefined && dataMenu.length > 0) {
      for (let index = 0; index <= dataMenu.length - 1; index++) {
        lengthSubMenu += dataMenu[index].subMenu.length
        if (dataMenu[index].subMenu.length === 0) {
          if (dataMenu[index].height === false) {
            lengthHideMenu++
          }
          lengthSubMenu++
        } else {
          let hide = dataMenu[index].subMenu.filter((item) =>
            item.height === false
          )
          lengthHideMenu += hide.length
        }
      }
    }
    if (lengthHideMenu === lengthSubMenu) {
      return false
    } else {
      return true
    }
  }

  const checkDisplaySubMenuAdmin = (data) => {
    let hide = data?.filter((item) =>
      item?.height === false || item?.href === ''
    )
    if (hide.length === data.length) {
      return false
    } else {
      return true
    }
  }

  const checkDisplaySubMenuManager = (data) => {
    let hide = data?.filter((item) =>
      item?.height === false || item?.href === ''
    )
    if (hide.length === data.length) {
      return false
    } else {
      return true
    }
  }

  const getRoute = (code, route_path = null) => {
    let path = (route_path !== null) ? route_path : false

    if (route_path) {
      path = permission !== undefined && permission !== null ? permission.filter((item) => item.view === true && item.code === code).length > 0 ? route_path : "" : ""
    }
    else {
      path = permission !== undefined && permission !== null ? permission.filter((item) => item.view === true && item.code === code).length > 0 ? true : false : false
    }

    return path
  }

  const listReport = () => {
    let menus = []

    const reports = (permission || []).filter((item) => item.view === true && item.code.startsWith('report_'))
    if (reports.length > 0) {

      for (const item of reports) {

        let idx = findIndex(menus, { title: item.permission_group })
        if (idx === -1) {
          idx = menus.length
          menus.push({
            icon: Report,
            title: item.permission_group,
            config: true,
            subMenu: [],
          })
        }
        let filterData = Util.formatData(menus[idx].subMenu, []).filter((rs) => rs.code === item.code.replace('report_', ''))
        if (filterData.length === 0) {
          menus[idx].subMenu.push({
            href: getRoute(item.code, "/admin/report/" + item.code.replace('report_', '')),
            icon: "",
            title: item.name,
            config: true,
            height: getRoute(item.code),
            code: item.code.replace('report_', '')
          })
        }

      }

    }

    //setMenuReport(menus)
    return menus
  }

  const items = [
    {
      href: "/kpi/home",
      icon: Home,
      title: t("sidebar.label.home"),
      // code: ""
    },
    {
      // href: "/app/inbox",
      href: "/kpi/inbox",
      icon: Inbox,
      title: t("sidebar.label.inbox"),
    },
    {
      // href: "/app/workload-and-performance",
      href: "",
      icon: Book,
      title: t("sidebar.label.planning"),
    },
    {
      href: "/kpi/announcement/allnews",
      // href: "",
      icon: FileText,
      title: t("sidebar.label.announcement"),
    },
  ];
  const listExternal = () => {
    const external = (permission || []).filter((item) => item.view === true && item.code === "menu_external")
    if (external.length > 0) {

      for (const item of external) {

        let idx = findIndex(items, { title: item.permission_group })
        if (idx === -1) {
          idx = items.length
          items.push({
            href: getRoute("menu_external", item?.external_url),
            icon: External,
            title: item?.name,
            newTab: item?.is_external,
            is_external: true,
            subMenu: [],
          })
        }
      }

    }
    return items
  }
  const itemsMain = listExternal()
  const itemSubnav = [
    {
      // href: "/app/planning",
      href: "",
      icon: FileText,
      title: t("sidebar.label.evaluationForm"),
    },
  ]
  const itemSubnavKpi = [
    {
      href: getRoute("my_achievement", "/kpi/achievement"),
      icon: Achievements,
      title: t("sidebar.label.achievements"),
      height: getRoute("my_achievement"),
    },
    {
      href: getRoute("my_goal", "/kpi/mygoal"),
      icon: Goals,
      title: t("sidebar.label.goals"),
      height: getRoute("my_goal"),
    },
    {
      href: getRoute("my_competency", "/kpi/competency"),
      icon: Competencies,
      title: t("sidebar.label.competencies"),
      height: getRoute("my_competency"),
    },
    {
      href: getRoute("my_evaluation", "/kpi/evaluation"),
      icon: FileText,
      title: t("sidebar.label.evaluation"),
      height: getRoute("my_evaluation"),
    },
    {
      href: getRoute("my_feedback", "/kpi/my-feedback"),
      icon: MyFeedbacks,
      title: t("sidebar.label.myFeedback"),
      height: getRoute("my_feedback"),
    },
    {
      href: getRoute("my_evaluation_360", "/kpi/my360evaluation"),
      icon: Evaluation360,
      title: t("sidebar.label.my360evaluation"),
      height: getRoute("my_evaluation_360"),
    },
    // {
    //   href: "",
    //   icon: HistoryEvaluation,
    //   title: t("sidebar.label.evaluationHistory"),
    // },
  ]
  const itemSubnavManage = [
    {
      href: getRoute("manager_evaluation", "/kpi/performance-evaluation"),
      icon: EvaluationManage,
      title: t("sidebar.label.evaluationManage"),
      height: getRoute("manager_evaluation"),
      subMenu: []
    },
    {
      icon: UserCircle,
      title: t("sidebar.label.dashboard.dashboard"),
      subMenu: [
        {
          href: getRoute("dashboard_achievement", "/kpi/dashboard/achievement"),
          // href: "/kpi/dashboard/achievement",
          icon: "",
          title: t("sidebar.label.dashboard.achievement"),
          height: getRoute("dashboard_achievement"),
        },
        {
          href: getRoute("dashboard_goal", "/kpi/dashboard/goal"),
          // href: "/kpi/dashboard/goal",
          icon: "",
          title: t("sidebar.label.dashboard.goal"),
          height: getRoute("dashboard_goal"),
        },
        {
          href: getRoute("dashboard_competency", "/kpi/dashboard/competency"),
          // href: "/kpi/dashboard/competency",
          icon: "",
          title: t("sidebar.label.dashboard.competency"),
          height: getRoute("dashboard_competency"),
        },
        {
          href: getRoute("dashboard_evaluation", "/kpi/dashboard/evaluation"),
          // href: "/kpi/dashboard/evaluation",
          icon: "",
          title: t("sidebar.label.dashboard.evaluation"),
          height: getRoute("dashboard_evaluation"),
        }
      ]
    },
    {
      href: getRoute("calibration", "/kpi/calibration"),
      icon: EvaluationManage,
      title: t("sidebar.label.calibration"),
      height: getRoute("calibration"),
      subMenu: []
    },
    {
      href: getRoute("manager_evaluation_360", "/kpi/360evaluation-manager"),
      icon: Evaluation360,
      title: t("sidebar.label.360evaluation"),
      height: getRoute("manager_evaluation_360"),
      subMenu: []
    },
  ]
  const itemsMore = [
    {
      href: "/kpi/manual/listbooks",
      // href: "",
      icon: FileText,
      title: t("sidebar.label.manual"),
    },
    {
      href: "/kpi/faq/listfaq",
      // href: "",
      icon: FileText,
      title: t("sidebar.label.faq"),
    },
  ]

  const itemAdmin = [
    {
      href: "",
      icon: LaunchForm,
      title: t("sidebar.label.launchForm"),
      subMenu: [
        {
          href: getRoute("launch_form", "/admin/launch-form"),
          icon: "",
          title: t("sidebar.label.launchForm"),
          height: getRoute("launch_form"),
        },
        {
          href: getRoute("manage_form", "/admin/manage-form"),
          icon: "",
          title: t("sidebar.label.manageForm"),
          height: getRoute("manage_form"),
        },
        {
          href: getRoute("target_group", "/admin/target-group"),
          icon: "",
          title: t("sidebar.label.targetGroup"),
          height: getRoute("target_group"),
        },
      ]
    },
    {
      icon: FileText,
      title: t("sidebar.label.evaluationAdmin"),
      subMenu: [
        {
          href: getRoute("evaluation_template", "/admin/evaluation-journey"),
          icon: "",
          title: t("sidebar.label.evaluationJourney"),
          height: getRoute("evaluation_template"),
        },
        {
          href: getRoute("evaluation_type", "/admin/evaluation-type"),
          icon: "",
          title: t("sidebar.label.evaluationType"),
          height: getRoute("evaluation_type"),
        },
        {
          href: getRoute("idp_template", "/admin/idp-template"),
          icon: "",
          title: t("sidebar.label.IDPTemplate"),
          height: getRoute("idp_template"),
        },
        {
          href: getRoute("evaluation_cycle", "/admin/cycle"),
          icon: "",
          title: t("sidebar.label.cycle"),
          height: getRoute("evaluation_cycle"),
        },
        {
          href: getRoute("evaluation_workflow", "/admin/workflow"),
          icon: "",
          title: t("sidebar.label.workflow"),
          height: getRoute("evaluation_workflow"),
        },
        {
          href: getRoute("evaluation_scale", "/admin/scaling-master"),
          icon: "",
          title: t("sidebar.label.scaleMaster"),
          height: getRoute("evaluation_scale"),
        },
        {
          href: getRoute("evaluation_custom_form", "/admin/custom-form-template"),
          icon: "",
          title: t("sidebar.label.customFormTemplate"),
          height: getRoute("evaluation_custom_form"),
        },
      ]
    },
    {
      href: "",
      icon: Goals,
      title: t("sidebar.label.goal"),
      subMenu: [
        {
          href: getRoute("goal_corporate", "/admin/manage-corporate-goal"),
          icon: "",
          title: t("sidebar.label.manageCorporateGoal"),
          height: getRoute("goal_corporate"),
        },
        {
          href: getRoute("goal_library", "/admin/goal-library-master"),
          icon: "",
          title: t("sidebar.label.goalLibrary"),
          height: getRoute("goal_library"),
        },
        {
          href: getRoute("goal_component", "/admin/goal-component"),
          icon: "",
          title: t("sidebar.label.goalComponent"),
          height: getRoute("goal_component"),
        },
      ]
    },
    {
      href: "",
      icon: Competencies,
      title: t("sidebar.label.competency"),
      subMenu: [
        {
          href: getRoute("competency_mapping", "/admin/competency-mapping"),
          icon: "",
          title: t("sidebar.label.competencyMapping"),
          height: getRoute("competency_mapping"),
        },
        {
          href: getRoute("competency_master", "/admin/competency-master"),
          icon: "",
          title: t("sidebar.label.competencyMaster"),
          height: getRoute("competency_master"),
        },
        {
          href: getRoute("competency_type", "/admin/competency-type"),
          icon: "",
          title: t("sidebar.label.competencyType"),
          height: getRoute("competency_type"),
        },
      ]
    },
    {
      href: "",
      icon: Profile,
      title: t("sidebar.label.profile"),
      subMenu: [
        {
          href: getRoute("profile_photo_admin", "/admin/profile"),
          icon: "",
          title: t("sidebar.label.profilePhoto"),
          height: getRoute("profile_photo_admin"),
        },
        {
          href: getRoute("job", "/admin/job-data"),
          icon: "",
          title: t("sidebar.label.jobData"),
          height: getRoute("job"),
        },
        {
          href: getRoute("position", "/admin/position-data"),
          icon: "",
          title: t("sidebar.label.positionData"),
          height: getRoute("position"),
        },
        {
          href: getRoute("organization", "/admin/organization"),
          icon: "",
          title: t("sidebar.label.organization"),
          height: getRoute("organization"),
        },
      ]
    },
    {
      href: getRoute("announcement", "/admin/announcement"),
      icon: Announcement,
      title: t("sidebar.label.announcementAdmin"),
      height: getRoute("announcement"),
      subMenu: []
    },
    {
      href: "",
      icon: Calibration,
      title: t("sidebar.label.calibration"),
      subMenu: [
        {
          href: getRoute("calibration_template", "/admin/calibration-template"),
          icon: "",
          title: t("sidebar.label.calibrationTemplate"),
          height: getRoute("calibration_template"),
        },
        {
          href: getRoute("calibration_session", "/admin/calibration-session"),
          icon: "",
          title: t("sidebar.label.calibrationSession"),
          height: getRoute("calibration_session"),
        },
      ]
    },
    {
      href: getRoute("user", "/admin/security"),
      icon: Security,
      title: t("sidebar.label.security"),
      height: getRoute("user"),
      subMenu: []
    },
    {
      href: getRoute("email_notification_center", "/admin/email-notification-center"),
      icon: EmailNotification,
      title: t("sidebar.label.emailNotificationCenter"),
      height: getRoute("email_notification_center"),
      subMenu: []
    },
    {
      href: getRoute("import_data", "/admin/import"),
      icon: ImportFile,
      title: t("sidebar.label.importFile"),
      height: getRoute("import_data"),
      subMenu: []
    },
  ]

  const itemReport = listReport()

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);
  const useStyles = makeStyles({
    clickable: {
      color: "#5DA196",
      textDecoration: "underline",
      cursor: "pointer",
      "&:hover, &:focus": {
        color: "#00846e",
      },
    },
    expandableIcon: {
      background: "#404349",
      // padding: 3,
      width: '20px',
      height: '20px',
      borderRadius: 3,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: '.3s',
      transform: "rotate(90deg)",
      '&.active': {
        transform: "rotate(-90deg)",
      }
    },
  });
  const classes = useStyles();
  let selectName = (data) => {
    if (data !== undefined && data?.profile !== undefined) {
      let dataProfile = data?.profile
      if (i18n.language === "th-TH" && dataProfile?.options?.name_th !== undefined && dataProfile?.options?.name_th !== null && dataProfile?.options?.name_th !== "") {
        return dataProfile?.options?.name_th;
      } else if (dataProfile?.options?.name_en !== undefined && dataProfile?.options?.name_en !== null && dataProfile?.options?.name_en !== "") {
        return dataProfile?.options?.name_en;
      } else {
        return dataProfile?.fullname;
      }
    }
    return "";
  }
  let selectNameUser = (data) => {
    if (data !== undefined && data?.profile !== undefined) {
      let dataProfile = data?.profile
      if (i18n.language === "th-TH" && dataProfile?.options?.name_th !== undefined && dataProfile?.options?.name_th !== null && dataProfile?.options?.name_th !== "") {
        return dataProfile?.options?.name_th;
      } else if (dataProfile?.options?.name_en !== undefined && dataProfile?.options?.name_en !== null && dataProfile?.options?.name_en !== "") {
        return dataProfile?.options?.name_en;
      } else {
        return dataProfile?.firstname + ` ` + dataProfile?.lastname
      }
    }
    return "";
  }

  let selectPosition = (data) => {
    if (data !== undefined && data?.profile !== undefined) {
      let dataProfile = data?.profile
      if (i18n.language === "th-TH" && dataProfile?.options?.position_th !== undefined && dataProfile?.options?.position_th !== null && dataProfile?.options?.position_th !== "") {
        return dataProfile?.options?.position_th;
      } else if (dataProfile?.options?.position_en !== undefined && dataProfile?.options?.position_en !== null && dataProfile?.options?.position_en !== "") {
        return dataProfile?.options?.position_en;
      } else {
        return dataProfile?.position;
      }
    }
    return "";
  }
  const content = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        padding: "44px 22px 0 22px"
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          // p: 2,
        }}
      >
        <Avatar
          src={proxy?.proxy_token === undefined ? imageProfile : proxy?.profile?.photo}
          sx={{
            cursor: "pointer",
            width: 161,
            height: 161,
          }}
        />
        <Typography color="white" variant="h5" sx={{ paddingTop: "20px", textAlign: "center" }}>
          {proxy?.proxy_token !== undefined ? selectName(proxy) : selectNameUser(dataProfiles)}
        </Typography>
        <Typography color="white" fontSize={14} lineHeight="20.93px" sx={{ paddingTop: "10px", textAlign: "center" }}>
          {proxy?.proxy_token !== undefined ? selectPosition(proxy) : selectPosition(dataProfiles)}
        </Typography>
        <Box sx={{ border: "1px solid #FFFFFF", boxShadow: " 0px 2px 2px rgba(0, 0, 0, 0.1)", borderRadius: "4px", marginTop: "12px" }}>
          <Button to="/app/profile" component={RouterLink} color="white" style={{ textTransform: 'none' }} sx={{ fontSize: "16px", fontWeight: "500" }}>{t("sidebar.label.viewProfile")}</Button>
        </Box>
      </Box>
      <Grid sx={{ marginTop: "26px" }}>
        <Divider style={styles.colorDivider} />
      </Grid>
      <Box >
        <List>
          {itemsMain.map((item) => (
            type === 'kpi' && item.title === t("sidebar.label.planning") ?
              null
              :
              type === 'rubric' && item.title === t("sidebar.label.announcement") ?
                null
                :
                <NavItem
                  hide={item.height}
                  href={item.href}
                  key={item.title}
                  title={item.title}
                  icon={item.icon}
                  newTab={item.newTab}
                  is_external={item.is_external}
                />
          ))}
        </List>
      </Box>
      <Divider style={styles.colorDivider} />
      {type === 'Rubric' ?
        <>
          <Box sx={{ padding: "22px 10px 0 10px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography color="white">
                {t("sidebar.label.rubric")}
              </Typography>
              <div className={`clickable ${classes.expandableIcon} ${isCollapse ? 'active' : ''}`} onClick={handleCollapse} id="prevent"><ArrowForwardIosIcon sx={{ fontSize: "0.9rem" }} id="prevent" /></div>
            </Box>
            <Collapse in={isCollapse}>
              <List sx={{ paddingLeft: "32px" }}>
                {itemSubnav.map((item) => (
                  <NavItem
                    hide={item.height}
                    href={item.href}
                    key={item.title}
                    title={item.title}
                    icon={item.icon}
                  />
                ))}
              </List>
            </Collapse>
          </Box>
          <Divider style={styles.colorDivider} />
        </>
        :
        <>
          <Box sx={{ padding: isCollapse ? "22px 10px 0px 10px" : "22px 10px 22px 10px", display: checkDisplayMenuKpi() === false ? "none" : "block" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography color="white">
                {t("sidebar.label.goalsAndCompetencies")}
              </Typography>
              <div className={`clickable ${classes.expandableIcon} ${isCollapse ? 'active' : ''}`} onClick={handleCollapse} id="prevent"><ArrowForwardIosIcon sx={{ fontSize: "0.9rem" }} id="prevent" /></div>
            </Box>
            <Collapse in={isCollapse}>
              <List>
                {itemSubnavKpi.map((item) => (
                  position !== true && item.title === t("sidebar.label.evaluationHistory") ?
                    null
                    :
                    <NavItem
                      hide={item.height}
                      href={item.href}
                      key={item.title}
                      title={item.title}
                      icon={item.icon}
                    />
                ))}
              </List>
            </Collapse>
          </Box>
          {/* <Divider style={styles.colorDivider} /> */}
          {checkDisplayMenuKpi() === false ?
            null : <Divider style={styles.colorDivider} />
          }
          <>
            <Box sx={{ padding: isCollapseManage ? "22px 10px 0px 10px" : "22px 10px 22px 10px", display: checkDisplayMenuManage() === false ? "none" : "block" }} >
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography color="white">
                  {t("sidebar.label.forManager")}
                </Typography>
                <div className={`clickable ${classes.expandableIcon} ${isCollapseManage ? 'active' : ''}`} onClick={handleCollapseManage} id="prevent"><ArrowForwardIosIcon sx={{ fontSize: "0.9rem" }} id="prevent" /></div>
              </Box>
              {/* <Collapse in={isCollapseManage}>
                <List >
                  {itemSubnavManage.map((item) => (
                    <NavItem
                      hide={item.height}
                      href={item.href}
                      key={item.title}
                      title={item.title}
                      icon={item.icon}
                    />
                  ))}
                </List>
              </Collapse> */}
              <Collapse in={isCollapseManage}>
                <List>
                  {
                    itemSubnavManage.map((item) => !item?.subMenu || item?.subMenu?.length < 1 ?
                      (
                        <NavItem
                          hide={item.height}
                          href={item.href}
                          key={item.title}
                          title={item.title}
                          icon={item.icon}
                        />
                      )
                      : !checkDisplaySubMenuManager(item?.subMenu) ? null
                        : (
                          <Box sx={{ padding: valueName === item.title ? "12px 0px 0px 8px" : "12px 0px 12px 8px" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Box sx={{ marginRight: "10px", display: "flex", alignItems: "center" }}>
                                  <img style={{ fontSize: "18px" }} src={item.icon} />
                                </Box>
                                <Typography fontSize={16} fontWeight={500} color="white">
                                  {item.title}
                                </Typography>
                              </Box>
                              <div className={`clickable ${classes.expandableIcon} ${valueName === item.title ? 'active' : ''}`} onClick={e => handleCollapseManageSub(item.title)} id="prevent"><ArrowForwardIosIcon sx={{ fontSize: "0.9rem" }} id="prevent" /></div>
                            </Box>
                            <Collapse in={valueName === item.title ? true : false}>
                              {
                                item.subMenu.map((rs) => {
                                  if (rs.height)
                                    return (
                                      <List sx={{ py: 0 }}>
                                        <NavItem
                                          hide={rs.height}
                                          href={rs.href}
                                          key={rs.title}
                                          title={rs.title}
                                          icon={rs.icon}
                                          sx={{ pl: "9px", height: "48px", mt: "5px" }}
                                        />
                                      </List>
                                    )
                                })
                              }
                            </Collapse>
                          </Box>
                        )

                    )
                  }
                </List>
              </Collapse>
            </Box>
            {checkDisplayMenuManage() === false ?
              null : <Divider style={styles.colorDivider} />
            }
          </>
          {/* {checkDisplayMenuManage() === false ?
            null : <Divider style={styles.colorDivider} />
          } */}

          <>
            <Box sx={{ padding: isCollapseAdmin ? "22px 10px 0px 10px" : "22px 10px 22px 10px", display: checkDisplayMenuAdmin(itemAdmin) === false ? "none" : "block" }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography color="white">
                  {t("sidebar.label.forAdmin")}
                </Typography>
                <div className={`clickable ${classes.expandableIcon} ${isCollapseAdmin ? 'active' : ''}`} onClick={handleCollapseAdmins} id="prevent"><ArrowForwardIosIcon sx={{ fontSize: "0.9rem" }} id="prevent" /></div>
              </Box>
              <Collapse in={isCollapseAdmin}>
                <List>
                  {itemAdmin.map((item) => item.subMenu !== undefined && item.subMenu.length < 1 ?
                    (
                      <NavItem
                        hide={item.height}
                        href={item.href}
                        key={item.title}
                        title={item.title}
                        icon={item.icon}
                      />
                    )
                    :
                    checkDisplaySubMenuAdmin(item.subMenu) === false ? null
                      :
                      <Box sx={{ padding: (valueName === item.title && typeMenu === 'admin') ? "12px 0px 0px 10px" : "12px 0px 12px 10px" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box sx={{ marginRight: "10px" }}>
                              <img style={{ fontSize: "18px" }} src={item.icon} />
                            </Box>
                            <Typography fontSize={16} fontWeight={500} color="white">
                              {item.title}
                            </Typography>
                          </Box>
                          <div className={`clickable ${classes.expandableIcon} ${(valueName === item.title && typeMenu === 'admin') ? 'active' : ''}`} onClick={e => handleCollapseAdmin(item.title, 'admin')} id="prevent"><ArrowForwardIosIcon sx={{ fontSize: "0.9rem" }} id="prevent" /></div>
                        </Box>
                        <Collapse in={(valueName === item.title && typeMenu === 'admin') ? true : false}>
                          <List>
                            {item.subMenu.map((rs) => (
                              <NavItem
                                hide={rs.height}
                                href={rs.href}
                                key={rs.title}
                                title={rs.title}
                                icon={rs.icon}
                              />
                            ))}
                          </List>
                        </Collapse>
                      </Box>
                  )}
                </List>
              </Collapse>
            </Box>
            {/* <Divider style={styles.colorDivider} /> */}
            {checkDisplayMenuAdmin(itemAdmin) === false ?
              null : <Divider style={styles.colorDivider} />
            }
          </>
        </>
      }

      {(itemReport.length > 0) &&
        <>
          <Box sx={{ padding: isCollapseReport ? "22px 10px 0px 10px" : "22px 10px 22px 10px", display: checkDisplayMenuAdmin(itemReport) === false ? "none" : "block" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography color="white">
                {t("sidebar.label.report")}
              </Typography>
              <div className={`clickable ${classes.expandableIcon} ${isCollapseReport ? 'active' : ''}`} onClick={handleCollapseReport} id="prevent"><ArrowForwardIosIcon sx={{ fontSize: "0.9rem" }} id="prevent" /></div>
            </Box>
            <Collapse in={isCollapseReport}>
              <List>
                {itemReport.map((item) => item.subMenu !== undefined && item.subMenu.length < 1 ?
                  (
                    <NavItem
                      hide={item.height}
                      href={item.href}
                      key={item.title}
                      title={item.title}
                      icon={item.icon}
                      config={item.config}
                    />
                  )
                  :
                  checkDisplaySubMenuAdmin(item.subMenu) === false ? null
                    :
                    <Box sx={{ padding: (valueName === item.title && typeMenu === 'report') ? "12px 0px 0px 10px" : "12px 0px 12px 10px" }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Box sx={{ marginRight: "10px" }}>
                            <img style={{ fontSize: "18px" }} src={item.icon} />
                          </Box>
                          <Typography fontSize={16} fontWeight={500} color="white">
                            {item.title}
                          </Typography>
                        </Box>
                        <div className={`clickable ${classes.expandableIcon} ${(valueName === item.title && typeMenu === 'report') ? 'active' : ''}`} onClick={e => handleCollapseAdmin(item.title, 'report')} id="prevent"><ArrowForwardIosIcon sx={{ fontSize: "0.9rem" }} id="prevent" /></div>
                      </Box>
                      <Collapse in={(valueName === item.title && typeMenu === 'report') ? true : false}>
                        <List>
                          {item.subMenu.map((rs) => (
                            <NavItem
                              hide={rs.height}
                              href={rs.href}
                              key={rs.title}
                              title={rs.title}
                              icon={rs.icon}
                              config={item.config}
                            />
                          ))}
                        </List>
                      </Collapse>
                    </Box>
                )}
              </List>
            </Collapse>
          </Box>
          {checkDisplayMenuAdmin(itemReport) === false ?
            null : <Divider style={styles.colorDivider} />
          }
        </>
      }

      {/* <Box sx={{ flexGrow: 1 }} /> */}

      {!isSSO &&
        <Box >
          <List>
            {itemsMore.map((item) => (
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
              />
            ))}
            <NavItemLogOut
              title={t("sidebar.label.logOut")}
              icon={LogOutIcon}
            />
          </List>
        </Box>
      }

    </Box >
  );
  return (
    <>
      <Drawer
        anchor="left"
        onClose={onMobileClose}
        open={openMobile}
        variant="temporary"
        classes={{ paper: 'black--bg white--text' }}
        PaperProps={{
          sx: {
            width: 256,
          },
        }}
      >
        {content}
      </Drawer>
    </>
  );
};
DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};
DashboardSidebar.defaultProps = {
  onMobileClose: () => { },
  openMobile: false,
};
export default DashboardSidebar;